export const SEAT_ATTRINUTES = [
  { code: 'W', value: 'Window seat' },
  { code: 'A', value: 'Aisle seat' },
];

export const SEATS = {
  CHILD_SEAT: 'label.child-seat',
  BASSINET: 'label.bassinet',
};

export const FLIGHT_STATUS_CODE = {
  UN: 'UN',
};

export const MY_CAR_VALET_STATUS_NOT_APPLIED = 'label.notRegistered';

export const LANG_LIST = {
  LANGS: [
    { code: 'ja', label: 'label.japan' },
    { code: 'en', label: 'label.english' },
  ],
};

export const DATA_CODE = {
  PD_035: 'PD_035',
  PD_126: 'PD_126',
  PD_950: 'PD_950',
  PD_113: 'PD_113',
  PD_800: 'PD_800',
  PD_930: 'PD_930',
  PD_006: 'PD_006',
  PD_007: 'PD_007',
  PD_710: 'PD_710',
  PD_720: 'PD_720',
  PD_730: 'PD_730',
  PD_740: 'PD_740',
  PD_750: 'PD_750',
};

export const SEAT_CHARACTERISTICS = {
  CODE_B: 'B',
};
export const LOCATION_CODOE_NGO = 'NGO';
export const LOCATION_CODOE_JP = 'JP';

export const NOT_REGISTERED = 'label.seatRevervation.notRegistered';
export const LANGUAGE_JP = 'ja';
export const LANGUAGE_EN = 'en';
export const LANGUAGE_SPANISH = 'es';
export const LANGUAGE_ITALIAN = 'it';
export const POS_COUNTRY_CODE_JP = 'JP';
export const POS_COUNTRY_CODE_JA = 'JA';
export const POS_COUNTRY_CODE_MX = 'MX';
export const POS_COUNTRY_CODE_IT = 'IT';

/** ルフトハンザ */
export const LUFTHANSA = 'LH';

export const LABEL_LOUNGE_NAME = {
  LOUG1: 'label.loungeName.ssrLoug1',
  LOUG2: 'label.loungeName.ssrLoug2',
  MYLG: 'label.loungeName.ssrMylg',
};

export const MEAL_TYPE_STORE = {
  ANCILLARY: 'ancillary',
};

export const SERVICE_NAMES = {
  CALL_CENTER_REQUEST_BAGGAGE_OR_FIRST_BAGGAGE: 'callCenterRequestBaggageOrfirstBaggage',
  FIRST_BAGGAGE: 'firstBaggage',
  MY_CAR_VALET: 'myCarValet',
  LOUNGE: 'lounge',
};

export const LOUNGE_SSR_CODE = {
  LOUG: 'LOUG',
  MYLG: 'MYLG',
};
